import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBudget = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 16q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 14q0-.825.588-1.412A1.93 1.93 0 0 1 12 12q.825 0 1.412.588Q14 13.175 14 14t-.588 1.412A1.93 1.93 0 0 1 12 16M7.375 7h9.25l2-4H5.375zM8.4 21h7.2q2.25 0 3.825-1.562T21 15.6q0-.95-.325-1.85a5.4 5.4 0 0 0-.925-1.625L17.15 9H6.85l-2.6 3.125a5.4 5.4 0 0 0-.925 1.625A5.4 5.4 0 0 0 3 15.6q0 2.275 1.563 3.838Q6.125 21 8.4 21" })
});
export default SvgBudget;
